import PosterImage from "./PosterImage"

const CardMoviesSkeleton = ({ id }) => {
    return (
        <div key={id} className="flex font-sans rounded-lg shadow-md bg-white">
            <div className="flex-none animate-pulse w-48 relative">
                <PosterImage />
            </div>
            <div className="flex-auto animate-pulse p-6">
                <div className=" w-full">
                    <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
                    <div className="h-2 w-2/4 bg-gray-200 rounded-full dark:bg-gray-700 mb-1"></div>
                    <div className="h-2 w-2/4 bg-gray-200 rounded-full dark:bg-gray-700 mb-4"></div>
                    <div className="h-2 w-2/4 bg-gray-200 rounded-full dark:bg-gray-700 mb-8"></div>
            
                    <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-1"></div>
                    <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>

                </div>
            </div>
        </div>
    )
}

export default CardMoviesSkeleton
